import { differenceInDays, differenceInMonths, format } from "date-fns";
import { isNumber, uniq } from "lodash";

import { DateFormat } from "constants/date";
import { ReportDistribution } from "constants/reports/distribution";
import { getDateByWeekday } from "helpers/date";

export function getColumnEvenOddClassName(index: number, shift = 0): string {
  return (index + shift) % 2 === 0 ? "even" : "odd";
}

/**
 * Calculate how long is the longest period from the series. It's feature to know how many single date columns should be presented on
 * @param uniqueDateRanges
 * @param distribution
 */
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getLongestPeriod(uniqueDateRanges: any, distribution: ReportDistribution): number {
  return Math.max(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...uniqueDateRanges.map((dateRangeString: any) => {
      const dates = dateRangeString.split("_");
      const differenceFnc = distribution === ReportDistribution.Day ? differenceInDays : differenceInMonths;
      return differenceFnc(dates[1], dates[0]) + 1;
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getUniqueDateRanges(series: any): string[] {
  return uniq<string>(
    series // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .map((s: any) => {
        if (s.filters) {
          if (s.filters.dateFrom && s.filters.dateTo) {
            return `${s.filters.dateFrom}_${s.filters.dateTo}`;
          }
          if (s.filters.weekday) {
            const date = getDateByWeekday(s.filters.weekday);
            return `${format(date, DateFormat.HtmlInputDate)}_${format(date, DateFormat.HtmlInputDate)}`;
          }
        }
        return null;
      })
      .filter(Boolean)
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function combineSimilarSeries(seriesData: any[]): any[] {
  const concatData = seriesData.reduce((acc, singleSeries) => {
    const key = `${singleSeries.name}_${singleSeries.agent}_${singleSeries.group}`;

    const currentRowTotal = acc[key] ? acc[key].total : 0;

    acc[key] = {
      ...acc[key],
      ...singleSeries,
      total: currentRowTotal + (isNumber(singleSeries.total) ? singleSeries.total : 0),
    };

    return acc;
  }, {});

  return Object.keys(concatData).map(key => concatData[key]);
}
